!(function (Helpers, $, undefined) {
  "use strict";

  // var announceFilterState = function(isExpanded) {
  //   var announcer = document.getElementById('boost-pfs-filter-announcer');
  //   if (!announcer) return;
    
  //   var message = isExpanded ? 'Filter + Sort expanded' : 'Filter + Sort collapsed';
    
  //   // Clear and set with timeout to ensure announcement
  //   announcer.textContent = '';
  //   setTimeout(function() {
  //     announcer.textContent = message;
  //   }, 100);
  // };

  var announceFilterState = function(isExpanded) {
    var announcer = document.getElementById('boost-pfs-filter-announcer');
    if (!announcer) return;
    
    var filterContent = document.querySelector('#offcanvas_filter .offcanvas_filter_content');
    
    if (isExpanded) {
      // Hide content from screen readers initially
      if (filterContent) {
        filterContent.setAttribute('aria-hidden', 'true');
      }
      
      var message = 'Filter + Sort expanded';
      announcer.textContent = '';
      announcer.setAttribute('aria-live', 'assertive');
      
      setTimeout(function() {
        announcer.textContent = message;
        
        // After announcement, reveal the content
        setTimeout(function() {
          if (filterContent) {
            filterContent.setAttribute('aria-hidden', 'false');
          }
          announcer.setAttribute('aria-live', 'polite');
        }, 1000);
      }, 100);
    } else {
      announcer.textContent = '';
      setTimeout(function() {
        announcer.textContent = 'Filter + Sort collapsed';
      }, 100);
    }
  };

  var toggleOffcanvas = function (offcanvas_id) {
    $(offcanvas_id).toggleClass("show");
    $("body").toggleClass("offcanvas-active");
    $(".screen-overlay").toggleClass("show");
  };

  // Append .background-image-holder <img>'s as CSS backgrounds
  var initBackgroundImages = function () {
    $(".background-image-holder").each(function () {
      var imgSrc = $(this).children("img").attr("src");
      $(this).css("background", 'url("' + imgSrc + '")');
      $(this).children("img").hide();
      $(this).css("background-position", "initial");
    });

    // Fade in background images
    setTimeout(function () {
      $(".background-image-holder").each(function () {
        $(this).addClass("fadeIn");
      });
    }, 200);
    function updateCartCount(cart) {
      var itemCount = Number(cart && cart.item_count) || 0;

      if (itemCount > 0) {
        $(".cart_badge").text(itemCount);
        $(".cart_badge").show();
      } else {
        $(".cart_badge").hide();
      }

      var itemText = itemCount === 1 ? "item" : "items";
      var ariaLabel = "Shopping cart containing " + itemCount + " " + itemText;

      $(".navbar_cart_link").not(".mobile_cart_link").attr("aria-label", ariaLabel);
    }

    $(document).on("cart.ready", function (event, cart) {
      updateCartCount(cart);
    });
    $(document).on("cart.requestComplete", function (event, cart) {
      updateCartCount(cart);
    });

    $(".main_nav_bar.nav_overlay").hover(
      function () {
        $(this).removeClass("nav_color_light");
      },
      function () {
        $(this).addClass("nav_color_light");
      }
    );
    if ($(".faq_block_wrapper").length) {
      var $faqMobileNav = $("#faq_mobile_nav_content");

      // The FAQ page supplies a purposeful Contact link in Liquid. Only build
      // legacy section links for templates whose mobile navigation is empty.
      if ($faqMobileNav.children().length === 0) {
        $(".faq_block_wrapper").each(function (index, element) {
          var headingText = $(element).find("h3").text();
          var headingLink = $(element).attr("id");
          var toReturn =
            '<a href="#' +
            headingLink +
            '" class="nav-link faq_nav_link">' +
            headingText +
            "</a>";
          $faqMobileNav.append(toReturn);
        });
      }

      $(".faq_block_wrapper").wrapAll(
        "<div class='container' id='faq_wrapper' /><div class='row'/>"
      );
    }

    function isEmail(email) {
      var EmailRegex =
        /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return EmailRegex.test(email);
    }

    $(document).on("click", ".submit_notify_me", function (e) {
      e.preventDefault();
      $("#notify_me_email").removeClass("is-invalid");

      if (isEmail($("#notify_me_email").val())) {
        var email = $("#notify_me_email").val();
        var variant_id = $("#notify_me_variant_id").val();

        if (!variant_id) {
          alert("Variant ID is missing.");
          return;
        }

        var variant_id_formatted = "$shopify:::$default:::" + variant_id;

        var payload = {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                  },
                },
              },
              channels: ["EMAIL"],
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: variant_id_formatted,
                },
              },
            },
          },
        };

        $.ajax({
          url: "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=L8vD3i",
          type: "POST",
          data: JSON.stringify(payload),
          contentType: "application/json",
          headers: {
            revision: "2024-06-15",
          },
          success: function (data, textStatus, xhr) {
            if (xhr.status === 202) {
              $(".modal-body").html(
                "<h4>Got it! We've jotted down your email and will be in touch the minute this item is back on our shelves. Promise.</h4>"
              );
              $(".modal-footer").html(
                '<button class="btn btn-primary" data-dismiss="modal">Close</button>'
              );
            } else {
              alert("Unexpected response from the server.");
            }
          },
          error: function (xhr, status, error) {
            alert("Error - " + xhr.responseText);
          },
        });
      } else {
        $("#notify_me_email").addClass("is-invalid");
      }
    });
    // $(document).on("click", ".submit_notify_me", function (e) {
    //   //e.stopPropagation();
    //   e.preventDefault();
    //   $("#notify_me_email").removeClass("is-invalid");
    //   if (isEmail($("#notify_me_email").val())) {
    //     var formData = $("#pdp_notify_me_form").serializeArray();
    //     console.log(formData);
    //     $.ajax({
    //       url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
    //       data: formData,
    //       type: "POST",
    //       success: function (data) {
    //         if (data.success) {
    //           $(".modal-body").html(
    //             "<h4>Got it! We've jotted down your email and will be in touch the minute this item is back on our shelves. Promise.</h4>"
    //           );
    //           $(".modal-footer").html(
    //             '<button class="btn btn-primary " data-dismiss="modal" >Close</button>'
    //           );
    //         }
    //       },
    //       error: function (xhr, status, error) {
    //         alert("Error - " + errorMessage);
    //       },
    //     });
    //   } else {
    //     $("#notify_me_email").addClass("is-invalid");
    //   }
    // });
  };

  var bindUIActions = function () {
    $(document).ready(function () {
      $(document).on("click", function (event) {
        var searchBox = $(".search_box");
        var navbar = $(".navbar");

        if (
          !searchBox.is(event.target) &&
          searchBox.has(event.target).length === 0 &&
          !navbar.is(event.target) &&
          navbar.has(event.target).length === 0
        ) {
          searchBox.removeClass("show_search_box");
        }
      });
    });

    $(".desktop_search_link").click(function (e) {
      e.preventDefault();
      $(".search_box").toggleClass("show_search_box");
      $(".search_box input").val("");
    });
    $('[data-toggle="popover"]').popover();

    $(".first_level_link__dropdown").click(function (e) {
      e.preventDefault();
      const subMenu = $(this).next(".nested_nav_list");
      $(this).toggleClass("active");

      // Check if the current element has the class 'active' and set aria-expanded accordingly
      if ($(this).hasClass("active")) {
        subMenu.addClass("active");
        $(this).attr("aria-expanded", "true");
        $(this).find("#svg-mobile_dropdown_arrow").text("Up Arrow");
        console.log("ifara", $(this).find("#svg-mobile_dropdown_arrow"));
      } else {
        subMenu.removeClass("active");
        $(this).attr("aria-expanded", "false");
        $(this).find("#svg-mobile_dropdown_arrow").text("Down Arrow");
        console.log("elsara", $(this).find("#svg-mobile_dropdown_arrow"));
      }
    });

    $(".testimonial_carousel").flickity({
      // options
      cellSelector: ".testimonial_carousel_cell",
      cellAlign: "center",
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      resize: true,
      imagesLoaded: true,
      watchCSS: true,
      wrapAround: true,
    });
    $(".lp_testimonials .btn-carousel_next").click(function (e) {
      e.preventDefault();
      $(".testimonial_carousel").flickity("next", true);
    });

    $(".lp_testimonials .btn-carousel_prev").click(function (e) {
      e.preventDefault();
      $(".testimonial_carousel").flickity("previous", true);
    });

    $(".logo_carousel").flickity({
      // options
      cellAlign: "left",
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      resize: true,
      imagesLoaded: true,
      watchCSS: true,
      wrapAround: true,
    });

    $(".logo_carousel.btn-carousel_next").click(function (e) {
      e.preventDefault();
      $(".logo_carousel").flickity("next");
    });

    $(".logo_carousel.btn-carousel_prev").click(function (e) {
      e.preventDefault();
      $(".logo_carousel").flickity("previous");
    });
    setTimeout(function () {
      const featuredCollectionCarousel = $(
        ".featured_collection_carousel"
      ).flickity({
        // options
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        resize: true,
        imagesLoaded: true,
        on: {
          ready: function() {
            console.log('ready', document.querySelector('.featured_collection_carousel:not(.is-initialized)'));
            document.querySelector('.featured_collection_carousel:not(.is-initialized)').classList.add('is-initialized');
            }
          }
        });

      const featured_collection_carousel = document.querySelector(
        ".featured_collection_carousel"
      );

      const carousel_items = featured_collection_carousel ?
      featured_collection_carousel.querySelectorAll(
        ".carousel_product_card"
      )
      :
      [];

      const focusableSelectors = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

      function updateCellFocusability() {
        if (!featured_collection_carousel) return;
        featured_collection_carousel.querySelectorAll('.carousel_product_card').forEach(function(cell) {
          const hidden = cell.getAttribute('aria-hidden') === 'true';
          cell.querySelectorAll(focusableSelectors).forEach(function(el) {
            el.tabIndex = hidden ? -1 : 0;
          });
        });
      }

      featuredCollectionCarousel.on('settle.flickity', updateCellFocusability);
      updateCellFocusability();

      const scrollToItem = (item) => {
        featuredCollectionCarousel.flickity(
          "select",
          item.dataset.carouselindex
        );
      };

      carousel_items.forEach((item) => {
        item.addEventListener("focus", () => {
          scrollToItem(item);
        });
        item.addEventListener("focusin", () => {
          scrollToItem(item);
        });
      });
    }, 1000);


    $(".featured_collection .btn-carousel_next").click(function (e) {
      e.preventDefault();
      var targetCarousel = $(this).attr("rel");
      $("#" + targetCarousel).flickity("next", true);
    });

    $(".featured_collection .btn-carousel_prev").click(function (e) {
      e.preventDefault();
      var targetCarousel = $(this).attr("rel");
      $("#" + targetCarousel).flickity("previous", true);
    });

    $("[data-trigger]").on("click", function (e) {
      e.preventDefault();
      if (!$(this).hasClass("context_badge")) {
        e.stopPropagation();
        var offcanvas_id = $(this).attr("data-trigger");
        toggleOffcanvas(offcanvas_id);
      }
    });

    $(".btn-close, .screen-overlay").click(function (e) {
      $(".screen-overlay").removeClass("show");
      $(".offcanvas").removeClass("show");
      $("body").removeClass("offcanvas-active");
      Helpers.announceFilterState(false);
    });

    $(".navbar_cart_link").click(function (e) {
      e.preventDefault();
      const offcanvas_id = "#offcanvas_cart";
      toggleOffcanvas(offcanvas_id);
    });

    $(".mobile_menu_button").click(function (e) {
      e.preventDefault();
      const offcanvas_id = "#offcanvas_nav";
      const height =
        $(".main_nav_bar").outerHeight() + $(".top-banner").outerHeight();
      const css_updates = {
        top: height,
        paddingBottom: height,
      };

      $(offcanvas_id).css(css_updates);
      $(offcanvas_id).toggleClass("show");
      $("body").toggleClass("offcanvas-active");
      if ($("body").hasClass("offcanvas-active")) {
        console.log("1");
        toggleMenuAccessibility(true);
        $(".mobile_menu_button").attr("aria-expanded", "true");
        $("#menu_button_ico").hide();
        $("#menu_button_ico_close").show();
        if ($(".main_nav_bar").hasClass("nav_overlay")) {
          $(".main_nav_bar").addClass("mobile_nav_open");
        }
      } else {
        console.log("2");
        toggleMenuAccessibility(false);
        $(".mobile_menu_button").attr("aria-expanded", "false");
        $("#menu_button_ico").show();
        $("#menu_button_ico_close").hide();
        if ($(".main_nav_bar").hasClass("nav_overlay")) {
          $(".main_nav_bar").removeClass("mobile_nav_open");
          $(".main_nav_bar").addClass("nav_color_light");
        }
      }
    });

    $(document).ready(function () {
      document.addEventListener("keydown", function (e) {
        if (
          e.key === "Escape" &&
          $(".mobile_menu_button").attr("aria-expanded") === "true"
        ) {
          $(".mobile_menu_button").click();
        }
      });
    });

    function toggleMenuAccessibility(isOpen) {
      if (isOpen) {
        document.addEventListener("keydown", handleTabKey);
      } else {
        document.removeEventListener("keydown", handleTabKey);
      }
    }

    function handleTabKey(e) {
      const focusableElements = [
        document.querySelector(".navbar-toggler.mobile_menu_button"),
        ...document.querySelectorAll(".offcanvas_nav_content a"),
      ];
      const firstElement = focusableElements[0];
      const secondElement = focusableElements[1];
      const lastElement = focusableElements[focusableElements.length - 1];
      if (e.key === "Tab") {
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          } else if (document.activeElement === firstElement) {
            secondElement.focus();
            e.preventDefault();
          }
        }
      }
    }
    /* if (window.innerWidth > 767) {
        var tween = TweenMax.staggerTo(".value_prop_item", 1, {
          opacity: 1
        }, 1);
        ScrollTrigger.create({
          trigger: ".bas_value_props",
          start: "top top",
          end: "bottom center",
          pin: true,
          pinSpacing: true,
          animation: tween
        });
      } */

    // Prevent closing from click inside dropdown
    $(document).on("click", ".dropdown-menu", function (e) {
      e.stopPropagation();
    });
  };

  Helpers.init = function () {
    initBackgroundImages();
    bindUIActions();
  };
   Helpers.announceFilterState = announceFilterState;
})((window.Helpers = window.Helpers || {}), jQuery),
  (function (Collections, $, undefined) {
    var bindUIActions = function () {
      $("#FilterBy").on("change", function () {
        location.href = jQuery(this).val();
      });
      $("#SortBy").on("change", function () {
        location.href = jQuery(this).val();
      });

      $(".plp_filter_btn").click(function (e) {
        e.preventDefault();
        $("#offcanvas_filter").toggleClass("show");
        $("body").toggleClass("offcanvas-active");
        //$(".screen-overlay").toggleClass("show");
        var isExpanded = $("#offcanvas_filter").hasClass("show");
        Helpers.announceFilterState(isExpanded);
      });
    };

    Collections.init = function () {
      bindUIActions();

      if (window.innerWidth > 767) {
        ScrollTrigger.create({
          trigger: ".btn-trigger-filter",
          start: "top top",
          endTrigger: "footer",
          pin: true,
          pinSpacing: true,
        });
      }
    };
  })((window.Collections = window.Collections || {}), jQuery),
  (function (ProductPage, $, undefined) {
    ProductPage.product = false;
    ProductPage.variants = false;
    ProductPage.current_variant = false;

    ProductPage.optionsMap = {};

    var updateOptionsInSelector = function (selectorIndex) {
      switch (selectorIndex) {
        case 0:
          var key = "root";
          break;
        case 1:
          var key = jQuery(".single-option-selector:eq(0)").val();
          break;
      }

      if (selectorIndex == 0) {
        var selectedValue = $("#ProductSelect-" + selectorIndex).val();
        var key = selectedValue;
        console.log(selectorIndex, key);
        var availableOptions = ProductPage.optionsMap[key];
        console.log({
          availableOptions,
        });

        $(".variant_swatch").each(function (index, element) {
          var currentColor = $(this).val();
          if (availableOptions.includes(currentColor)) {
            console.log("not found");
            $(this).removeAttr("checked").parent(".btn").addClass("disabled");
          } else {
            $(this)
              .removeAttr("checked")
              .parent(".btn")
              .removeClass("disabled");
          }
        });
      } else if (selectorIndex == 1) {
        //console.log(selectorIndex, key);
        //var availableOptions = ProductPage.optionsMap[key];
        //console.log({availableOptions});
      }
    };

    var buildOptions = function (product) {
      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        if (variant.available) {
          // Gathering values for the 1st drop-down.
          ProductPage.optionsMap["root"] = ProductPage.optionsMap["root"] || [];
          ProductPage.optionsMap["root"].push(variant.option1);
          ProductPage.optionsMap["root"] = Shopify.uniq(
            ProductPage.optionsMap["root"]
          );
          // Gathering values for the 2nd drop-down.
          if (product.options.length > 1) {
            var key = variant.option1;
            ProductPage.optionsMap[key] = ProductPage.optionsMap[key] || [];
            ProductPage.optionsMap[key].push(variant.option2);
            ProductPage.optionsMap[key] = Shopify.uniq(
              ProductPage.optionsMap[key]
            );
          }
          // Gathering values for the 3rd drop-down.
          if (product.options.length === 3) {
            var key = variant.option1 + " / " + variant.option2;
            ProductPage.optionsMap[key] = ProductPage.optionsMap[key] || [];
            ProductPage.optionsMap[key].push(variant.option3);
            ProductPage.optionsMap[key] = Shopify.uniq(
              ProductPage.optionsMap[key]
            );
          }
        }
      }
    };

    var updatePrice = function () {
      var productPrice = ProductPage.current_variant.price;
      var originalPrice = ProductPage.current_variant.compare_at_price;
      console.log(Shopify.formatMoney(productPrice));
      // set proper format and update price UI
      $("[product-price]").html(Shopify.formatMoney(productPrice));
      // Select the element with ID 'accesibility-price'
      var accessibilityPriceElement =
        document.getElementById("accesibility-price");

      // Assuming Shopify.formatMoney(productPrice) is defined somewhere
      var formattedPrice = Shopify.formatMoney(productPrice);

      // Update the HTML content of the selected element with the formatted price
      if (accessibilityPriceElement) {
        console.log(accessibilityPriceElement);
        accessibilityPriceElement.innerHTML = `${formattedPrice} apiece`;
      }
      // If variant is on sale, update sale pricing UI
      if (productPrice < originalPrice) {
        $("[original-price]").html(Shopify.formatMoney(originalPrice));
        $("[original-price], .badge-sale").removeClass("d-none");
      } else {
        $("[original-price], .badge-sale").addClass("d-none");
      }
    };
    var updateVariantNameAccessibility = function () {
      var variantName = document.querySelector(".selected-text").innerHTML;
      var variantDisplayField = document.querySelector("#price-description");
      if (variantDisplayField) {
        variantDisplayField.innerHTML = "Variant:" + variantName;
      }
    };

    var updateImage = function () {
      var index = ProductPage.current_variant.featured_image.position - 1; // will give you 2
      var mipSlider = $(".mip-slider").data("flexslider");
      mipSlider.flexslider(index); // will take you to that slide
    };

    var updateHistoryState = function () {
      // Update history state for product deeplinking
      var newUrl = window.location.protocol + "//" + window.location.host;
      if (window.masterCollectionData) {
        var lastPart = window.location.pathname.replace(/.*\//, "");
        var url_split = window.location.pathname.split("/");
        if (url_split[url_split.length - 1].length > 0) {
          url_split[url_split.length - 1] = ProductPage.currentProduct.handle;
        } else {
          url_split[url_split.length - 2] = ProductPage.currentProduct.handle;
        }
        newUrl += url_split.join("/");
      } else {
        newUrl += window.location.pathname;
      }
      newUrl += "?variant=" + ProductPage.current_variant.id;

      window.history.replaceState(
        {
          path: newUrl,
        },
        "",
        newUrl
      );
    };

    var getProductOptions = function () {
      var currentOptions = jQuery.map(
        $("[single-product-selector]"),
        function (element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    };

    var getCurrentVariant = function (variantId) {
      var variants = ProductPage.variants;
      var found = jQuery.map(variants, function (variant) {
        if (variant.id == variantId) {
          return variant; // return matching variant object
        }
      });

      return found[0]; // returns single array so pull out first element object
    };

    function variantSearch(conditions) {
      return Object.keys(this).every((key) => conditions[key] === this[key]);
    }

    var bindUIActions = function () {
      var pdpImageCarousel = $(".pdp_image_gallery_main").flickity({
        cellAlign: "left",
        contain: true,
        cellSelector: ".pdp_image_gallery_item",
        autoPlay: false,
        watchCSS: true,
        prevNextButtons: false,
        wrapAround: true,
        imagesLoaded: true,
      });
      $(".input_spinner").TouchSpin({
        min: 1,
        max: 100,
        step: 1,
        decimals: 0,
        boostat: 5,
        maxboostedstep: 10
      });
      setTimeout(() => {
        $('.bootstrap-touchspin-down').attr('aria-label', 'Decrease quantity');
        $('.bootstrap-touchspin-up').attr('aria-label', 'Increase quantity');
      }, 100);
      // Variant change
      $("[variant-select]").on("change", function () {
        if ($(this).hasClass("grouped_swatch")) {
        } else {
          let optionIndex = $(this).data("index").replace("option", "");
          // updateOptionsInSelector(optionIndex);
        }

        if (
          $(this).data("type").toLowerCase() == "color" ||
          $(this).data("type").toLowerCase() == "pattern"
        ) {
          $(".selected_color_value").text(this.value);
        }
        var variant_options = $("[variant-select]");
        var toFind = [];
        $.each(variant_options, function (indexInArray, element) {
          if (element.type == "radio") {
            if ($(this).is(":checked")) {
              toFind[$(this).data("index")] = this.value;
            }
          } else {
            toFind[$(this).data("index")] = this.value;
          }
        });
        var variant = ProductPage.variants.find(variantSearch, toFind);
        if (variant) {
          ProductPage.current_variant = variant;
          $("[selected-variant-id]").val(variant.id);
          if (window.masterCollectionData) {
            currentProduct =
              window.masterCollectionData.products[variant.productId];
            if (currentProduct.id != ProductPage.currentProduct.id) {
              var windowWidth = $(document).width();

              ProductPage.currentProduct = currentProduct;
              //  console.log('prije', ProductPage);

              $(".product_description").html(
                ProductPage.currentProduct.description
              );
              setTimeout(() => {
                if (ProductPage.currentProduct.accordion_content) {
                  $("#pdp_detail_accordion").html(
                    ProductPage.currentProduct.accordion_content
                  );
                }
              }, 1000);

              var newMainHTML = '';
              var newThumbHTML = '';
              $.each(
                ProductPage.currentProduct.images,
                function (i, item) {
                  var activeClass = (i === 0) ? ' is-active' : '';
                  newMainHTML +=
                    '<div class="pdp_image_gallery_item' + activeClass + '" data-slide-index="' + i + '">' +
                    '<img src="' + item.src + '" class="img-fluid" alt="' + (item.alt || '') + '" />' +
                    '</div>';
                  var thumbSrc = item.src.replace(/(\.[a-z]+)(\?.*)?$/i, '_106x106_crop_center$1$2');
                  newThumbHTML +=
                    '<button class="pdp_thumb' + activeClass + '" data-slide-index="' + i + '" aria-label="View image ' + (i + 1) + '">' +
                    '<img src="' + thumbSrc + '" alt="' + (item.alt || '') + '" width="106" height="106" />' +
                    '</button>';
                }
              );

              $('.pdp_image_gallery_main').empty().append(newMainHTML);
              $('.pdp_image_gallery_thumbs_track').empty().append(newThumbHTML);
              window.dispatchEvent(new Event('pdp-gallery-reinit'));
              pdpImageCarousel.flickity('destroy');
              pdpImageCarousel = $(".pdp_image_gallery").flickity({
                cellAlign: "left",
                contain: true,
                cellSelector: ".pdp_image_gallery_item",
                autoPlay: false,
                watchCSS: true,
                prevNextButtons: false,
                wrapAround: true,
                imagesLoaded: true,
              });
            }
          }

          if (variant.available) {
            var btnString;
            // var preorderDate = ProductPage.current_variant.preorderDate2 ;
            $(".pdp_atc").removeClass("notify_me");
            if (ProductPage.current_variant.preorderDate) {
              btnString =
                "PREORDER - SHIPS " + ProductPage.current_variant.preorderDate;
              stickyAtcBrnString =
                "PREORDER - SHIPS " + ProductPage.current_variant.preorderDate;
            } else {
              btnString = "Add to Bag";
              stickyAtcBrnString = "ADD TO BAG -"
            }
            console.log('sssssssssssss', ProductPage.current_variant)
            $(".pdp_atc").html(btnString);
            $(".pdp_atc").prop("disabled", false);
            $("#sticky-atc-button .sticky-atc-text").text("ADD TO BAG - ");
            $("#sticky-atc-button .sticky-atc-price #sticky-atc-price").text('$' + Shopify.formatMoney(ProductPage.current_variant.price));
            // $('#sticky-atc-button').prop('disabled', false);
          } else {
            //$('.pdp_atc').prop('disabled', 'disabled');
            $(".pdp_atc").addClass("notify_me");
            $(".pdp_atc").html("Out Of Stock - Notify Me");
            $("#sticky-atc-button .sticky-atc-text").text("Out Of Stock - Notify Me");
            $("#sticky-atc-button .sticky-atc-price #sticky-atc-price").text("");
            // $('#sticky-atc-button').prop('disabled', 'disabled');

          }
          updatePrice(); // Updates display price and sale display

          $("#collapse_material-dimensions .card-body p").html(
            ProductPage.current_variant.materialsTab
          );

          setTimeout(function () {
            var slideIndex = 0;
            if (ProductPage.current_variant.featured_media) {
              slideIndex = ProductPage.current_variant.featured_media.position - 1;
            } else if (ProductPage.current_variant.featured_image) {
              slideIndex = ProductPage.current_variant.featured_image.position - 1;
            }
            if ($(document).width() >= 768) {
              if (window.pdpGalleryGoToSlide) {
                window.pdpGalleryGoToSlide(slideIndex);
              }
            } else {
              pdpImageCarousel.flickity('selectCell', slideIndex);
            }
          }, 50);

          //updateImage(); // Selects the assigend image in the carousel
          updateHistoryState(); // Adds Variant ID to URL for deeplinking
        } else {
          $(".pdp_atc").prop("disabled", "disabled");
          $(".pdp_atc").html("Sold Out");
        }
      });



// 1. On clicking notify_me button, prevent native submit but trigger submit event manually
$(document).on("click", ".pdp_atc.notify_me", function (e) {
  e.preventDefault();
  console.log("🛑 Click on notify_me button — preventing default submission");
  
  // Trigger form submit event manually on the closest form
  $(this).closest("form.pdp_form").trigger("submit");
});

// 2. Handle form submit event (modal or add to cart)
$(".pdp_form").submit(function (e) {
  e.preventDefault();
  console.log("FORM SUBMIT TRIGGERED BEFORE DEFAULT");
  console.log("FORM SUBMIT TRIGGERED AFTER");

  if ($(".pdp_atc").hasClass("notify_me")) {
    console.log("Notify me product — showing modal");
    $("#notify_me_variant_id").val(ProductPage.current_variant.id);
    $("#notify_me_product_id").val(ProductPage.currentProduct.id);
    $("#notifyMeModal").modal("show");
  } else {
    console.log("Adding product to cart");
    var extraData = [];
    if (ProductPage.current_variant.preorderDate) {
      extraData["_preorderDate"] = ProductPage.current_variant.preorderDate;
    }
     // Collect gift card recipient properties if the checkbox is checked
    var $form = $(this);
    var $recipientCheckbox = $form.find('input[type="checkbox"][name="properties[__shopify_send_gift_card_to_recipient]"]');
    if ($recipientCheckbox.length && $recipientCheckbox.is(':checked')) {
      extraData["__shopify_send_gift_card_to_recipient"] = "if_present";
      var emailVal   = $form.find('input[name="properties[Recipient email]"]').val();
      var nameVal    = $form.find('input[name="properties[Recipient name]"]').val();
      var messageVal = $form.find('textarea[name="properties[Message]"]').val();
      var sendOnVal  = $form.find('input[name="properties[Send on]"]').val();
      var offsetVal  = $form.find('input[name="properties[__shopify_offset]"]').val();
      if (emailVal)   extraData["Recipient email"]  = emailVal;
      if (nameVal)    extraData["Recipient name"]   = nameVal;
      if (messageVal) extraData["Message"]          = messageVal;
      if (sendOnVal)  extraData["Send on"]          = sendOnVal;
      if (offsetVal)  extraData["__shopify_offset"] = offsetVal;
    }
    CartJS.addItem(
      ProductPage.current_variant.id,
      $("#quantity").val(),
      extraData,
      {
        success: function () {
          console.log("Product added to cart successfully");
          $("#offcanvas_cart").toggleClass("show");
          $("body").toggleClass("offcanvas-active");
          $(".screen-overlay").toggleClass("show");
        },
        error: function () {
          alert(
            "Oops! There was a problem adding this item to your cart. It may no longer be available."
          );
        },
      }
    );
  }
});


      // OLD CODE FOR SHOWING UP MODAL NOTIFY ME & ADD TO CART

      // $(".pdp_form").submit(function (e) {
      //     console.log("FORM SUBMIT TRIGGERED BEFORE DEFAULT");
      //   e.preventDefault();
      //     console.log("FORM SUBMIT TRIGGERED AFTER");

      //   if ($(".pdp_atc").hasClass("notify_me")) {
      //     $("#notify_me_variant_id").val(ProductPage.current_variant.id);
      //     $("#notify_me_product_id").val(ProductPage.currentProduct.id);
      //     $("#notifyMeModal").modal("show");
      //   } else {
      //     var extraData = [];
      //     if (ProductPage.current_variant.preorderDate) {
      //       extraData["_preorderDate"] =
      //         ProductPage.current_variant.preorderDate;
      //     }
      //     CartJS.addItem(
      //       ProductPage.current_variant.id,
      //       $("#quantity").val(),
      //       extraData,
      //       {
      //         success: function (data, textStatus, jqXHR) {
      //           $("#offcanvas_cart").toggleClass("show");
      //           $("body").toggleClass("offcanvas-active");
      //           $(".screen-overlay").toggleClass("show");
      //         },
      //         error: function (jqXHR, textStatus, errorThrown) {
      //           alert(
      //             "Oops! There was a problem adding this item to your cart. It may no longer be available."
      //           );
      //         },
      //       }
      //     );
      //   }
      // });


      
    };

    ProductPage.init = function () {
      // Get Product JSON data
      ProductPage.product = JSON.parse(
        document.getElementById("ProductJson").innerHTML
      );
      ProductPage.currentProduct = ProductPage.product;
      if (window.masterCollectionData) {
        var variants = [];
        $.each(
          window.masterCollectionData.products,
          function (indexInArray, element) {
            variants.push(element.variants);
          }
        );
        variants = [].concat.apply([], variants);
        ProductPage.variants = variants;
      } else {
        ProductPage.variants = ProductPage.product.variants;
      }

      // buildOptions(ProductPage.product);
      ProductPage.current_variant = getCurrentVariant(
        $("[selected-variant-id]").val()
      );
      //ProductPage.productOptions = getProductOptions();

      bindUIActions();
    };
  })((window.ProductPage = window.ProductPage || {}), jQuery);

const focusableElements =
  'h5, p, span, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), ul.dropdown-menu li';
const modal = document.querySelector("#offcanvas_cart");

const firstFocusableElement = modal.querySelectorAll(focusableElements)[0];
const focusableContent = modal.querySelectorAll(focusableElements);
const lastFocusableElement = focusableContent[focusableContent.length - 1];

document.addEventListener("keydown", function (e) {
  let isTabPressed = e.key === "Tab" || e.keyCode === 9;

  if (!isTabPressed) {
    return;
  }

  if (e.shiftKey) {
    if (document.activeElement === firstFocusableElement) {
      lastFocusableElement.focus();
      e.preventDefault();
    }
  } else {
    if (document.activeElement === lastFocusableElement) {
      firstFocusableElement.focus();
      e.preventDefault();
    } else if (
      document.activeElement.classList.contains("dropdown-toggle") &&
      document.activeElement.getAttribute("aria-expanded") === "false" &&
      document.activeElement.getAttribute("data-toggle") === "dropdown" &&
      document.activeElement.getAttribute("data-tab-open") !== "true"
    ) {
      e.preventDefault();
      document.activeElement.setAttribute("data-tab-open", "true");
      document.activeElement.click();
    }
  }
});

document.addEventListener("keydown", function (e) {
  if (
    e.key === "Enter" &&
    (document.activeElement.classList.contains("dropdown-toggle") ||
      document.activeElement.classList.contains("pdp-custom-dropdown-toggle") ||
      document.activeElement.classList.contains("custom-dropdown-toggle") ||
      document.activeElement.classList.contains("custom-dropdown__option") ||
      document.activeElement.classList.contains("pdp-custom-dropdown__option"))
  ) {
    document.activeElement.click();
  }
});

firstFocusableElement.focus();

// add all the elements inside modal which you want to make focusable
const focusableElements2 =
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
const modal2 = document.querySelector("#offcanvas_filter"); // select the modal by it's id

const firstFocusableElement2 = modal2.querySelectorAll(focusableElements2)[0]; // get first element to be focused inside modal
const focusableContent2 = modal2.querySelectorAll(focusableElements2);
const lastFocusableElement2 = focusableContent2[focusableContent2.length - 1]; // get last element to be focused inside modal

document.addEventListener("keydown", function (f) {
  let isTabPressed2 = f.key === "Tab" || f.keyCode === 9;

  if (!isTabPressed2) {
    return;
  }

  if (f.shiftKey) {
    // if shift key pressed for shift + tab combination
    if (document.activeElement === firstFocusableElement2) {
      lastFocusableElement2.focus(); // add focus for the last focusable element
      f.preventDefault();
    }
  } else {
    // if tab key is pressed
    if (document.activeElement === lastFocusableElement2) {
      // if focused has reached to last focusable element then focus first focusable element after pressing tab
      firstFocusableElement2.focus(); // add focus for the first focusable element
      f.preventDefault();
    }
  }
});

firstFocusableElement2.focus();
